/**
 * RoyalDivider — ornamental SVG divider inspired by lotus + crown motifs.
 * Sits between sections. Renders in gold with royal accents.
 *
 * Props:
 *   label — optional word placed in the centre (e.g., "Chapter II")
 *   tone  — "light" (default, dark on cream) | "dark" (light on royal)
 */
export default function RoyalDivider({ label, tone = "light", className = "" }) {
  const stroke = tone === "dark" ? "#E4C46B" : "#C9A24A";
  const text = tone === "dark" ? "text-gold2" : "text-royal";
  return (
    <div className={`royal-divider ${className}`} role="separator" aria-label={label || "section divider"}>
      <div className="hidden sm:block" />
      <div className="flex items-center gap-3">
        <Ornament stroke={stroke} flip />
        {label ? (
          <span className={`font-hand text-lg ${text} tracking-wide`}>{label}</span>
        ) : (
          <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
            <circle cx="5" cy="5" r="3" fill={stroke} />
          </svg>
        )}
        <Ornament stroke={stroke} />
      </div>
    </div>
  );
}

function Ornament({ stroke, flip = false }) {
  return (
    <svg
      width="64" height="16" viewBox="0 0 64 16"
      aria-hidden="true"
      style={{ transform: flip ? "scaleX(-1)" : "none" }}
    >
      <path
        d="M2 8 Q10 2 18 8 T34 8 T50 8"
        fill="none" stroke={stroke} strokeWidth="1.2" strokeLinecap="round"
      />
      <circle cx="56" cy="8" r="1.6" fill={stroke} />
      <path
        d="M50 8 Q54 4 58 8"
        fill="none" stroke={stroke} strokeWidth="1" strokeLinecap="round" opacity="0.7"
      />
    </svg>
  );
}
